import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { partnerSkinNames } from '../../../../core/constants/partnerSkinEnums';
import goldPG from '../../../../assets/images/coinFlip/new-ver/coinFlip-gold.png';
import gold from '../../../../assets/images/coinFlip/gold.svg';
import goldVbet from '../../../../assets/images/coinFlip/vbet-version/coinFlip-gold.png';
import silverPg from '../../../../assets/images/coinFlip/new-ver/coinFlip-silver.png';
import silver from '../../../../assets/images/coinFlip/silver.svg';
import silverVbet from '../../../../assets/images/coinFlip/vbet-version/coinFlip-silver.png';
import goldBfth from '../../../../assets/images/coinFlip/bfth-version/coinFlip-gold.png';
import silverBfth from '../../../../assets/images/coinFlip/bfth-version/coinFlip-silver.png';

export const CoinFlipMarketType = {
  Heads: 0,
  Tails: 1,
};
export const CoinFlipMarketName = {
  [CoinFlipMarketType.Heads]: 'HEADS',
  [CoinFlipMarketType.Tails]: 'TAILS',
};

export const CoinFlipCoinImagesBySkin = {
  pg: { [CoinFlipMarketType.Heads]: goldPG, [CoinFlipMarketType.Tails]: silverPg },
  topc: { [CoinFlipMarketType.Heads]: gold, [CoinFlipMarketType.Tails]: silver },
  vbet: { [CoinFlipMarketType.Heads]: goldVbet, [CoinFlipMarketType.Tails]: silverVbet },
  vbetam: { [CoinFlipMarketType.Heads]: goldVbet, [CoinFlipMarketType.Tails]: silverVbet },
  bfth: { [CoinFlipMarketType.Heads]: goldBfth, [CoinFlipMarketType.Tails]: silverBfth },
};

export const CoinFlipMarketHeads = 'HEADS';
export const CoinFlipMarketTails = 'TAILS';

export const COIN_FLIP_GAME_ID = 48;

export const COIN_FLIP_ANIMATION_DURATION = 1000;
export const COIN_FLIP_ANIMATION_DURATION_TURBO = 400;

export const coinFlipResourcesNames = {
  background: 'background',
  coin: 'coin',
  vfx: 'vfx',
};

export const coinFlipAnimationNames = {
  goldGold: 'gold-gold',
  goldSilver: 'gold-silver',
  idle: 'idle',
  silverGold: 'silver-gold',
  silverSilver: 'silver-silver',
  winGold: 'winGold',
  winSilver: 'winSilver',
  looseGold: 'looseGold',
  looseSilver: 'looseSilver',
};

export const CoinFlipCanvasConfigMobile = {
  antialias: true,
  backgroundAlpha: 0,
  width: 359,
  height: 315,
};

export const CoinFlipCanvasConfigWeb = {
  antialias: true,
  backgroundAlpha: 0,
  width: 1027,
  height: 680,
};
export const gameResources = (partnerSkin) => {
  const animFileName = partnerSkinNames[partnerSkin];

  const coinFlipWebAnimationSources = {
    background: {
      name: coinFlipResourcesNames.background,
      path: `animations/coinFlip_${animFileName}/web/bg.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/coinFlip_${animFileName}/web/bg.atlas`,
        },
      },
    },
    coin: {
      name: coinFlipResourcesNames.coin,
      path: `animations/coinFlip_${animFileName}/web/coin.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/coinFlip_${animFileName}/web/coin.atlas`,
        },
      },
    },
    vfx: {
      name: coinFlipResourcesNames.vfx,
      path: `animations/coinFlip_${animFileName}/web/vfx.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/coinFlip_${animFileName}/web/vfx.atlas`,
        },
      },
    },
  };
  const coinFlipMobileAnimationSources = {
    background: {
      name: coinFlipResourcesNames.background,
      path: `animations/coinFlip_${animFileName}/mobile/bg.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/coinFlip_${animFileName}/mobile/bg.atlas`,
        },
      },
    },
    coin: {
      name: coinFlipResourcesNames.coin,
      path: `animations/coinFlip_${animFileName}/mobile/coin.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/coinFlip_${animFileName}/mobile/coin.atlas`,
        },
      },
    },
    vfx: {
      name: coinFlipResourcesNames.vfx,
      path: `animations/coinFlip_${animFileName}/mobile/vfx.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/coinFlip_${animFileName}/mobile/vfx.atlas`,
        },
      },
    },
  };
  return [
    ...Object.values(isMobile() ? coinFlipMobileAnimationSources : coinFlipWebAnimationSources),
  ];
};

export const CoinFlipLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const CoinFlipBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'market_type',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => {
      return (
        <span className='cpt-table-text'>
          {spinInfo.spinMarkets.length > 1 ? (
            <span
              className='multi-selection'
              onClick={(e) => {
                e.stopPropagation();
                popupStore.open({ name: PopupTypes.Fairness, spinInfo });
                checkHashStore.setSpinInfo({
                  salt: spinInfo.salt,
                  key: spinInfo.key,
                  hash: spinInfo.hash,
                });
              }}
            >
              {t(TranslationKeys.MultiSelection)}
            </span>
          ) : (
            t(CoinFlipMarketName[spinInfo.spinMarkets[0]])
          )}
        </span>
      );
    },
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const COINFLIP_RULES_KEYS = new Array(isPG() ? 17 : 7)
  .fill(null)
  .map((item, index) => index + 1);
export const COINFLIP_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
